import { breakpoints } from '@gassan-ui'
import styled, { css } from 'styled-components'
import { Button, buttonLabel } from '@rolex-ui'

export const FullWidthButton = styled.button<{ isOpen: boolean }>`
  ${buttonLabel};
  width: 100%;
  padding: 1rem;
  color: ${p => p.theme.rolex.colors.primary};
  background: #fff;
  height: 63px;
  z-index: ${p => (p.isOpen ? 100 : 2)};
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  outline: 0;
  -webkit-tap-highlight-color: transparent;

  ${p =>
    p.isOpen &&
    css`
      background: ${p => p.theme.rolex.colors.shades[100]};
      position: absolute;
      top: 0;
    `}
  svg {
    margin-left: 1rem;
  }
`

export const ResetButton = styled(Button)`
  height: 2.5rem;
  width: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 1rem;
  padding: 0.6875rem;

  svg {
    margin: 0;
  }

  @media screen and (min-width: ${breakpoints.large}) {
    height: initial;
    width: auto;
    margin-left: 0;
    padding: 0.6875rem 2rem;
    justify-content: initial;
    align-items: initial;

    svg {
      margin-right: 1.5rem;
    }
  }
  &:disabled {
    background: ${p => p.theme.rolex.colors.shades[200]};
    color: ${p => p.theme.rolex.colors.shades[700]};
    border-color: ${p => p.theme.rolex.colors.shades[200]};
    cursor: not-allowed;
  }
`

export const Content = styled.div`
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  padding: 0 5vw;
  background: ${p => p.theme.rolex.colors.shades[100]};
  display: none;
  height: 100%;
  overflow-y: scroll;
  padding-bottom: 5rem;
  padding-top: 63px;
  -webkit-scroll-behavior: smooth;
  overflow-y: hidden;
  z-index: 2;

  @media screen and (min-width: ${breakpoints.small}) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 4rem 1fr;
  }

  @media screen and (min-width: ${breakpoints.large}) {
    background: white;
    color: ${p => p.theme.rolex.colors.primary};
    display: block;
    position: relative;
    padding: 0;
  }
`

export const Footer = styled.div`
  position: fixed;
  background: #fff;
  bottom: 0;
  width: 100%;
  left: 0;
  height: 5rem;
  padding: 0 10px;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  z-index: 100;
  @media screen and (min-width: ${breakpoints.small}) {
    display: none;
  }
`

export const Wrapper = styled.aside<{ isOpen: boolean }>`
  @media screen and (max-width: ${breakpoints.large}) {
    display: none;
  }
  ${p =>
    p.isOpen &&
    css`
      @media screen and (max-width: ${breakpoints.large}) {
        display: block;
        position: fixed;
        width: 100%;
        height: 100%;
        z-index: 99;
        top: 0;
        left: 0;
        overflow-y: scroll;
        -webkit-scroll-behavior: smooth;

        ${FullWidthButton} {
          position: fixed;
          top: 0;
          left: 0;
          z-index: 100;
        }

        ${Content} {
          display: block;

          @media screen and (min-width: ${breakpoints.small}) {
            display: grid;
          }

          @media screen and (min-width: ${breakpoints.large}) {
            display: block;
          }
        }

        ${Footer} {
          display: flex;
        }
      }
    `}
`
